import Vue from 'vue'
import Vuex from 'vuex'
import { db } from './main'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        links: {},
    },

    getters: {
        getLinks: (state) => {
            return state.links
        }
    },

    mutations: {
        setLinks(state, payload) {
            state.links = payload
        }
    },

    actions: {
        loadLinkData(context) {
            db.collection('links').onSnapshot(
                (linksCollection) => {
                    let links = {}

                    linksCollection.forEach((link) => {
                        let linkData = link.data()
                        links[link.id] = linkData.url
                    })

                    context.commit('setLinks', links)
                },
                (error) => {
                    console.log(`Error loading links: ${error}`)
                }
            )
        }
    }
})
